export const defaultList = [{ key: "", value: "", isDisableClose: true }]
